import { render, staticRenderFns } from "./APSpacesHistory.vue?vue&type=template&id=1bf25342&scoped=true&"
import script from "./APSpacesHistory.vue?vue&type=script&lang=js&"
export * from "./APSpacesHistory.vue?vue&type=script&lang=js&"
import style0 from "./APSpacesHistory.vue?vue&type=style&index=0&id=1bf25342&lang=less&scoped=true&"
import style1 from "./APSpacesHistory.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf25342",
  null
  
)

component.options.__file = "APSpacesHistory.vue"
export default component.exports